import $storage from '../storage'

const NAVIGATOR_CONSTANT = {
	TAB: 'navigator-main',
	PAGE: 'navigator-page',
}

/**
 * 清除tab导航缓存
 * @author  韦胜健
 * @date    2019/3/6 14:03
 */
async function clearTab() {
	$storage.set(NAVIGATOR_CONSTANT.TAB, null)

	const storage = JSON.parse(localStorage.getItem('LinkUI')) || {}
	/*storage['navigator-main'] = null
	storage['navigator-page'] = null
	localStorage.setItem('LinkUI', JSON.stringify(storage))*/
}

class NavigatorService {

	context;
	_tab;
	_page;

	get main() {
		return this.context.$lv.$tab
	}

	get tab() {
		if (!this._tab) this._tab = this.context.$lv.$dom.findComponentUpward(this.context, 'pl-navigator-main-tab')
		return this._tab
	}

	get page() {
		if (!this._page) this._page = this.context.$lv.$dom.findComponentUpward(this.context, 'pl-navigator-main-page')
		return this._page
	}

	constructor(context) {
		this.context = context
	}

	/**
	 * 打开页签
	 * @author  韦胜健
	 * @date    2019/3/6 11:23
	 * @param   id          tab的id
	 * @param   title       tab的标题
	 * @param   path        tab根页面路径
	 * @param   param       tab根页面参数
	 * @param   data        tab页签额外的数据
	 * @param   security    tab的安全性
	 * @param   refresh     如果页面已经打开，是否刷新页面
	 * @param   storage     该页签是否缓存
	 * @param   iframe      页签是否显示的是一个外部网页地址
	 */
	async openTab({id, title, path, param, security, data, iframe, storage}, refresh = false) {
		return await this.main.open({id, title, path, param, security, data, iframe, storage}, refresh)
	}

	/**
	 * 关闭页签
	 * @author  韦胜健
	 * @date    2019/3/6 11:23
	 */
	async closeTab(id) {
		if (!id) id = this.tab.id
		return await this.main.close(id)
	}

	/**
	 * 刷新tab
	 * @author  韦胜健
	 * @date    2019/3/6 11:24
	 */
	async refreshTab(id) {
		id = id || this.tab.id
		return await this.main.refresh(id)
	}

	/**
	 * 刷新当前页面（不会刷新tab)
	 * @author  韦胜健
	 * @date    2019/7/8 12:01
	 */
	async refreshPage() {
		this.page.refresh()
	}

	/**
	 * 更新tab的信息
	 * @author  韦胜健
	 * @date    2019/3/6 11:38
	 */
	async updateTab(id, newTabData) {
		id = id || this.tab.id
		return await this.main.update(id, newTabData)
	}

	clearTab = clearTab


	/**
	 * 获取当前显示的tab数据信息
	 * @author  韦胜健
	 * @date    2019/3/14 19:17
	 */
	getCurrentTab() {
		return this.main.getCurrentTab()
	}

	/**
	 * 获取当前所有的tabs
	 * @author  韦胜健
	 * @date    2019/3/14 19:34
	 */
	getTabs() {
		return this.main.pageStack
	}

	/**
	 * 打开页面
	 * @author  韦胜健
	 * @date    2019/3/6 11:41
	 * @param   path            打开的页面的路径
	 * @param   param           打开页面传递的参数
	 * @param   security        打开页面时给的安全性，如果为null或者undefined，则会传入tab的安全性，想要设置该页面没有安全性，则设置空对象{}
	 * @param   iframe          打开的页面是否为一个外部地址，使用iframe窗口打开
	 */
	async push(path, param, security, iframe) {
		if (!!this.tab) return await this.tab.push(path, param, security, iframe)
	}

	/**
	 * 重定向到页面
	 * @author  韦胜健
	 * @date    2019/3/6 11:41
	 * @param   path            同push的path参数
	 * @param   param           同push的param参数
	 * @param   security        同push的security参数
	 * @param   iframe          同push的iframe参数
	 */
	async redirect(path, param, security, iframe) {
		this.tab.redirect(path, param, security, iframe)
	}

	/**
	 * 回退页面
	 * @author  韦胜健
	 * @date    2019/3/6 11:41
	 * @param   num             回退的页面的个数，默认回退一个页面
	 * @param   data            回退页面，给上一个页面传递的参数
	 */
	async back(data = null, num = 1) {
		if (!!this.tab) return await this.tab.back(data, num)
	}

	/**
	 * 某个页签内弹出所有页面
	 * @author  韦胜健
	 * @date    2019/2/27 15:40
	 * @param   data            回退到根页面，传递的参数
	 */
	async backoff(data) {
		if (!!this.tab) return await this.tab.backoff(data)
	}

	/**
	 * @method：backFreshList
	 * @createdBy:黄健
	 * @date: 2020-11-12
	 * @params:：
	 * @description: 返回上一个列表后刷新数据
	 */
	freshListOnBack() {
		if (!this.tab) return;
		this.tab.markBackFresh();
	}

	/**
	 * 开启/关闭 的加载状态
	 * @author  韦胜健
	 * @date    2019/10/10 14:07
	 */
	loading(flag = true) {
		if (!this.page) return;
		this.page.pageLoading = Boolean(flag);
		this.page.pageLoadingMsg = typeof flag !== 'string' ? '' : flag;
	}


	/*---------------------------------------事件-------------------------------------------*/
	/**
	 * 监听事件
	 * @author  韦胜健
	 * @date    2019/3/19 18:50
	 * @param   event       监听事件的名称
	 * @param   callback    派发事件时的回调动作
	 */
	$on(event, callback) {
		this.page.on(event, callback)
	}

	/**
	 * 只监听一次事件
	 * @author  韦胜健
	 * @date    2019/3/19 18:51
	 * @param   event       监听事件的名称
	 * @param   callback    派发事件时的回调动作
	 */
	$once(event, callback) {
		this.page.once(event, callback)
	}

	/**
	 * 移除事件
	 * @author  韦胜健
	 * @date    2019/3/19 18:51
	 * @param   event       监听事件的名称
	 * @param   callback    派发事件时的回调动作
	 */
	$off(event, callback) {
		this.page.off(event, callback)
	}

	/**
	 * 派发事件
	 * @author  韦胜健
	 * @date    2019/3/19 18:51
	 * @param   event       派发事件的名称
	 * @param   param       派发事件传递的参数
	 * @param   global      是否为全局事件，是则所有页签内注册event事件的页面都可以监听，否则只有同页签内注册事件的页面才能监听event事件
	 */
	$emit(event, param, global = false) {
		if (global) {
			this.main.emit(event, param)
		} else {
			this.page.emit(event, param)
		}
	}

	/**
	 * 在新窗口中打开页面
	 * @author  韦胜健
	 * @date    2019/3/1 16:00
	 * @param   path            新窗口页面地址s
	 * @param   param           新窗口页面接受的参数
	 * @param   security        新窗口页面的安全性，没有则使用tab的安全性
	 */
	async openWindow(path, param, security) {
		return new Promise(async (rs, rj) => {
			const pageData = {path, param, security}
			if (!!this.main.beforeOpenWindow) {
				await this.main.beforeOpenWindow(pageData)
			}
			path = pageData.path
			param = pageData.param
			security = pageData.security

			security = security || this.page.tab.security
			const pc = await this.main.p_pageRegistry(path)

			if (!pc) {
				rj()
				return
			}

			const id = path.replace(/\//g, '-')
			let storage = JSON.parse(window.localStorage.getItem('LinkSingle')) || {}
			storage[id] = {
				security,
				path,
				param,
				page404: this.main.page404,
				appCtx: window.CURRENT_ORIGIN_TOP.appCtx,
				title: document.title,
			}
			window.localStorage.setItem("LinkSingle", JSON.stringify(storage))
			path = LinkVue.$utils.pathJoin(LinkVue.publicPath, `/pages/single/index.html?id=${id}`)
			console.log('path -->', path)
			const newWin = window.open(path, '_blank')
			!!newWin && (newWin.onload = (...args) => rs(...args))

			!!this.main.afterOpenWindow && (await this.main.afterOpenWindow({path, param, security}))
			rs()
		})
	}

	/**
	 * 输出成功信息
	 * @author  韦胜健
	 * @date    2019/4/24 16:06
	 */
	success(e, tag) {
		this.context.$message.success(e);
	}

	/**
	 * 输出错误信息
	 * @author  韦胜健
	 * @date    2019/4/24 16:07
	 */
	error(e, tag) {
		console.error(e);
		this.context.$dialog.error({
			title: '系统异常',
			message: LinkUtils.typeOf(e) === 'string' ? e : String(e),
		});
		if (!!this.page) {
			const {iframe, param, path, security} = this.page.page
			linkLog.error(JSON.stringify({tag, page: {iframe, param, path, security}, e}));
		} else {
			linkLog.error(JSON.stringify({tag, page: 'no page', e}));
		}
	}

	/**
	 * 输出警告信息
	 * @author  韦胜健
	 * @date    2019/5/6 16:18
	 */
	warn(e, tag) {
		console.warn(e);
		this.context.$message({message: e, type: 'warning'});
		if (!!this.page) {
			const {iframe, param, path, security} = this.page.page
			linkLog.warn(JSON.stringify({tag, page: {iframe, param, path, security}, e}));
		} else {
			linkLog.warn(JSON.stringify({tag, page: 'no page', e}));
		}
	}
}

const LinkModuleInjectMixin = {
	// 注入当前页签所属模块名称及对应的$http实例到所有组件，默认使用Vue.prototype.$http
	// 源provide位于src/link-components/navigator-main/pl-navigator-main-page.vue
	inject: {
		$http: {
			// 不能重名，不然会取原型上的$http实例
			from: '$linkModuleHttp',
			default: () => window.LinkVue.Vue.prototype.$http
		},
		$lov: {
			// 不能重名，不然会取原型上的$http实例
			from: '$linkModuleLov',
			default: () => window.LinkVue.Vue.prototype.$lov
		},
		$linkModule: {
			from: '$linkModule',
			default: ''
		}
	},
}

const NavigatorMixin = {
	props: {
		pageTabData: {},
		pageSecurity: {},
		pageParam: {},
	},
	data() {
		const p_ns = new NavigatorService(this)
		return {
			p_ns,
		}
	},
	computed: {
		$nav() {
			if (!this) {
				console.error('nav未初始化')
				throw new Error('nav未初始化')
			}
			return this.p_ns
		},
	},
}

class NavigatorTab {

	id;
	title;
	path;
	param;
	security;
	data;
	iframe;
	storage;

	component;
	init;

	constructor(option) {
		Object.assign(this, option)
		this.init = true
		this.path = this.path.trim()
	}

	static getStorage(target) {
		return Object.assign({}, target, {component: null, init: null})
	}
}

export {
	LinkModuleInjectMixin,
	NavigatorMixin,
	NAVIGATOR_CONSTANT,
	clearTab,
	NavigatorTab,
}
